const actionTypes = {
    LOGIN: 'LOGIN',
    REGISTER_SUCCESS: 'REGISTER_SUCCESS',
    REGISTER_FAILED: 'REGISTER_FAILED',
    SIGNIN_SUCCESS: 'SIGNIN_SUCCESS',
    SIGNIN_FAILED: 'SIGNIN_FAILED',
    LOGOUT: 'LOGOUT',

    GET_POSTS: 'GET_POSTS',
    GET_POSTS_LIMIT: 'GET_POSTS_LIMIT',
    GET_POSTS_LIMIT_ADMIN: 'GET_POSTS_LIMIT_ADMIN',
    GET_NEW_POSTS: 'GET_NEW_POSTS',
    GET_OUT_STANDING_POSTS: 'GET_OUT_STANDING_POSTS',
    DATAEDIT: 'DATAEDIT',
    RESET_DATAEDIT: 'RESET_DATAEDIT',

    GET_CATEGORIES: 'GET_CATEGORIES',

    GET_PRICES: 'GET_PRICES',
    GET_AREAS: 'GET_AREAS',
    GET_PROVINCES: 'GET_PROVINCES',

    GET_CURRENT: 'GET_CURRENT'

}

export default actionTypes